import _toConsumableArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectDestructuringEmpty from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectDestructuringEmpty.js";
import React from "react";
var __jsx = React.createElement;
import stl from './RecommendationSlider.module.css';
import { useTranslation } from "@i18n";
import { useEffect, useState } from "react";
import { api__getRecommendedPosts } from "@/apis/posts/recommendation";
import { Link } from "react-router-dom";
import { trackEvents } from "@/common/events/events";
import useHelpers from "@hooks/useHelpers";
import { CDN_LINK } from "@globalConfig";
import { checkFeatureFlag } from "@/common/config/websiteConfig";
import { useSession } from "@/_MiniApps/auth/AuthContext";
import useCookieClient from "@hooks/useCookieClient";
import { ModernCard } from "@/components/SearchComponent/ModernCard";
import Container from "@/components/sharedComponents/container/Container";
import RecommendationSliderSkeleton from "@/pages/homePageV2/homePageComponents/components/recommendation/RecommendationSliderSkeleton";

/** ---------------------------------------- **/

var RecommendationSlider = function RecommendationSlider(_ref) {
  _objectDestructuringEmpty(_ref);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState([]),
    similar = _useState[0],
    setSimilar = _useState[1];
  var _useState2 = useState(true),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  var _useSession = useSession(),
    userData = _useSession.user;
  var _useCookieClient = useCookieClient(),
    getCookieClient = _useCookieClient.getCookieClient;
  var userId = getCookieClient("UUID") || null;
  useEffect(function () {
    if (!checkFeatureFlag("FF_RECOMMENDATION_ENABLED")) {
      return;
    }
    var userId = getCookieClient("UUID") || null;
    if (!userId) {
      setLoading(false);
      return;
    }
    api__getRecommendedPosts(userId, 4).then(function (data) {
      if (data !== null && data !== void 0 && data.length) {
        setSimilar(_toConsumableArray(data));
      }
      setLoading(false);
    });
    return function () {
      return setSimilar([]);
    };
  }, [userId]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Container, {
    className: "mt-8 lg:mt-0"
  }, loading ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.big
  }, /*#__PURE__*/React.createElement("h2", null, t("cars", {
    ns: "web_common"
  }))), /*#__PURE__*/React.createElement("ul", {
    className: stl.cardsWrapper
  }, Array.from({
    length: 4
  }).map(function (_, idx) {
    return /*#__PURE__*/React.createElement(RecommendationSliderSkeleton, {
      key: "un-skeleton-".concat(idx)
    });
  }))) : /*#__PURE__*/React.createElement(React.Fragment, null, (similar === null || similar === void 0 ? void 0 : similar.length) > 0 && /*#__PURE__*/React.createElement("div", {
    className: stl.big
  }, /*#__PURE__*/React.createElement("h2", {
    id: "recommendation_section_title"
  }, t("cars", {
    ns: "web_common"
  }))), /*#__PURE__*/React.createElement("ul", {
    className: [stl.cardsWrapper, (similar === null || similar === void 0 ? void 0 : similar.length) < 3 ? stl.cardsWrapperMin : ''].join(' ')
  }, similar === null || similar === void 0 ? void 0 : similar.map(function (post, idx) {
    return /*#__PURE__*/React.createElement("li", {
      className: stl.card,
      key: "li-".concat(idx),
      id: "recommendation-card-".concat(idx + 1)
    }, /*#__PURE__*/React.createElement(ModernCard, {
      key: post.id,
      post: post,
      fromHomePage: true,
      rank: idx + 1,
      page: 1,
      sectionType: "recomended",
      titleTag: "h3",
      onClick: function onClick() {
        var user_uuid = getCookieClient("UUID") || null;
        trackEvents("recommendation_car_clicked", {
          uuid: user_uuid || null,
          post_id: post.id,
          referral_location: "home"
        });
      }
    }));
  }), similar.length > 3 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("li", {
    className: stl.showAllRecommendedCars
  }, /*#__PURE__*/React.createElement(Link, {
    to: createUrl("/site/recommendation-list"),
    className: stl.showAllLinkMobile,
    onClick: function onClick() {
      var user_uuid = getCookieClient("UUID") || null;
      trackEvents("recommendation_listing_page_viewed", {
        uuid: user_uuid || null,
        referral_location: "home"
      });
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: stl.showAllText
  }, t("show_cars", {
    ns: "web_common"
  })), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("img", {
    className: stl.arrowLeft,
    src: CDN_LINK + "/assets/images/arrow-left-white.svg",
    alt: "Left arrow"
  })))))), similar.length > 3 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.showRecommendedCarsSection
  }, /*#__PURE__*/React.createElement(Link, {
    to: createUrl("/site/recommendation-list"),
    onClick: function onClick() {
      var user_uuid = getCookieClient("UUID") || null;
      trackEvents("recommendation_listing_page_viewed", {
        uuid: user_uuid || null,
        referral_location: "home"
      });
    },
    className: stl.showAllRecommendedCarsButton,
    id: "recommendation_recommended-slider-cta"
  }, t("view_suggested_cars", {
    ns: "web_common"
  })))))));
};
export default RecommendationSlider;